<template>
    <div class="action-selector">
        <div class="text-center" v-if="opened" v-on-clickaway="close">
            <div v-for="action in actions" :key="action" @click="click(action)"
                class="icon" :class="actionsOn[action] ? 'on' : 'off'">
                <component v-bind:is="actionIcon(action)" height="24" />
            </div>
        </div>
        <div class="text-center py-11" v-if="! opened" @click="opened = true">
            {{ $t('select') }}
        </div>
    </div>
</template>

<script>
import IconPersonal from '@/components/visual/icons/actions/IconPersonal'
import IconHaircut from '@/components/visual/icons/actions/IconHaircut'
import IconManicure from '@/components/visual/icons/actions/IconManicure'
import IconClothes from '@/components/visual/icons/actions/IconClothes'
import IconTravel from '@/components/visual/icons/actions/IconTravel'
import IconTakecredit from '@/components/visual/icons/actions/IconTakecredit'
import IconGivecredit from '@/components/visual/icons/actions/IconGivecredit'
import { mapState, mapGetters } from 'vuex'
import { mixin as clickaway } from 'vue-clickaway'
export default {
    components: { IconHaircut, IconManicure, IconClothes, IconTravel, IconTakecredit, IconGivecredit, IconPersonal },
    mixins: [ clickaway ],
    data() {
        return {
            opened: false,
            counter: 0,
            timer: undefined,
        }
    },
    methods: {
        toggle(action) {
            this.$store.dispatch('predictions/actionToggle', action)
        },
        only(action) {
            this.$store.dispatch('predictions/actionOnly', action)
        },
        click(action) {
            this.counter++

            if(this.counter == 1) {
                this.timer = setTimeout(() => {
                    this.counter = 0
                    this.toggle(action)
                }, 300)
                return
            }

            clearTimeout(this.timer)
            this.counter = 0
            this.only(action)
        },
        close() {
            if (this.opened) 
                this.opened = false
        },
    },
    computed: {
        ...mapState('predictions', ['actions', 'actionsOn']),
        ...mapGetters('predictions', ['actionIcon']),
    },
}
</script>

<i18n locale="ru" lang="yaml">
    select: "Выбрать благоприятности"
</i18n>

<i18n locale="en" lang="yaml">
</i18n>
